var exports = {
  "Rq": "MfaTotpEnableModal.module__qrContainer___c0U5UT",
  "JB": "MfaTotpEnableModal.module__qrCode___c0U5UT",
  "DM": "MfaTotpEnableModal.module__instructionsContainer___c0U5UT",
  "u_": "MfaTotpEnableModal.module__setupDescription___c0U5UT",
  "sO": "MfaTotpEnableModal.module__secretBlock___c0U5UT",
  "tx": "MfaTotpEnableModal.module__secretRow___c0U5UT",
  "iO": "MfaTotpEnableModal.module__secretLabel___c0U5UT",
  "yD": "MfaTotpEnableModal.module__secretText___c0U5UT",
  "iA": "MfaTotpEnableModal.module__buttonIcon___c0U5UT",
};

module.exports = exports;
